import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VAutocomplete, _vm._b({
    class: {
      required: _vm.required
    },
    attrs: {
      "items": _vm.items,
      "label": _vm.label,
      "color": _vm.color,
      "disabled": _vm.mode === 'readonly',
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "label",
      "item-value": "zone",
      "hide-no-data": "",
      "hide-details": "",
      "clearable": _vm.clearable
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('input', _vm.selectedItem);
      },
      "click:clear": _vm.setGuessedTimezone
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.label))]), _c(VListItemSubtitle, [_vm._v(_vm._s(item.offset))])], 1)];
      }
    }]),
    model: {
      value: _vm.selectedItem,
      callback: function ($$v) {
        _vm.selectedItem = $$v;
      },
      expression: "selectedItem"
    }
  }, 'v-autocomplete', {
    ..._vm.$attrs,
    ..._vm.commonAttrs
  }, false));
};
var staticRenderFns = [];
export { render, staticRenderFns };